import React, { useState, useEffect } from 'react';
import { Box, Button, View } from '@common/components';
import {
  path09,
  puzzle09,
  puzzle0902,
  door08,
  clue06,
  scenarioBg,
} from '../assets/images';
import { connect } from 'react-redux';
import { setNavigation } from '@resources/Navigation/actions';
import ImageMapper from 'react-image-mapper';
import { Col, Row, Modal, message } from 'antd';
import CombinationLock from 'combination-lock-react';
import { addPuzzle } from '@resources/Puzzle/actions';
import { addClue } from '@resources/Clue/actions';
import { doAction } from '@resources/Action/actions';
import { getCookie } from '@common/utils/cookie';
import { isEmpty } from 'lodash';
import {
  CheckCircleFilled,
  CloseCircleOutlined,
  LockFilled,
} from '@ant-design/icons';
import { updateMember } from '@resources/Member/actions';
import { addSolve } from '@resources/Solve/actions';
import { addStory } from '@resources/Story/actions';
import { setEnd } from '@resources/End/actions';
import Help from '@games/GrandHotelPro/fragments/Help';
import ReactPlayer from 'react-player';
import { setAudio } from '@resources/Audio/actions';

const Outside = ({
  end,
  setNavigation,
  socket,
  solves,
  match,
  history,
  doAction,
  clues,
  updateMember,
  addSolve,
  addStory,
  setEnd,
  setAudio,
}) => {
  const u = getCookie('GHPuser') ? JSON.parse(getCookie('GHPuser')) : {};
  const [solved, setSolved] = useState(false);
  const location = 'Outside';
  const [visiblePuzzle06, setVisiblePuzzle06] = useState(false);
  const [visiblePuzzle0602, setVisiblePuzzle0602] = useState(false);
  const [visibleClue06, setVisibleClue06] = useState(false);
  const [roomScenario, setRoomScenario] = useState(true);
  const { params } = match || {};
  const { channelId } = params;
  const width = 1920;
  const height = 1040;
  // const solvedPuzzles = getCookie('solved')
  // 	? JSON.parse(getCookie('solved'))
  // 	: [];

  const MAP = {
    name: 'my-map',
    areas: [
      {
        name: 'puzzle06',
        shape: 'circle',
        coords: [1043, 646, 30],
      },
      {
        name: 'puzzle0602',
        shape: 'circle',
        coords: [980, 620, 40],
      },
    ],
  };

  useEffect(() => {
    if (
      !isEmpty(socket) &&
      history &&
      history.location &&
      history.location.pathname === `/grand-hotel-pro/${channelId}/play/map`
    ) {
      if (!isEmpty(socket)) {
        doAction({
          game: 'grand-hotel-pro',
          channel: socket.channel,
          event: 'member',
          message: {
            id: socket.id,
            name: u.name,
            location: location,
            game: 'grand-hotel-pro',
          },
        });
        doAction({
          game: 'grand-hotel-pro',
          channel: socket.channel,
          event: 'log',
          message: {
            id: socket.id,
            name: u.name,
            location: location,
            channel: channelId,
            message: `has moved to ${location}`,
            game: 'grand-hotel-pro',
          },
        });
        updateMember({ id: socket.id, name: u.name, location });
        // doAction({
        // 	channel: socket.channel,
        // 	event: 'clues',
        // 	message: clues,
        // });
      }
    }
  }, [socket, history]);

  useEffect(() => {
    if (
      history &&
      history.location &&
      history.location.pathname === `/grand-hotel-pro/${channelId}/play/map`
    ) {
      setNavigation({
        backward: {
          title: 'Lobby',
          onPress: () => {
            history.push(`/grand-hotel-pro/${channelId}/play/lobby`);
          },
          image: door08,
        },
        forward: null,
      });
    }
  }, [clues, solves, history]);

  const handleClick = (area) => {
    if (area.name === 'puzzle06') {
      setVisiblePuzzle06(true);
      doAction({
        game: 'grand-hotel-pro',
        channel: socket.channel,
        event: 'log',
        message: {
          id: socket.id,
          name: u.name,
          location: location,
          channel: channelId,
          message: 'has opened the Outside puzzle',
          game: 'grand-hotel-pro',
        },
      });
    }

    if (area.name === 'puzzle0602') {
      setVisiblePuzzle0602(true);
      doAction({
        game: 'grand-hotel-pro',
        channel: socket.channel,
        event: 'log',
        message: {
          id: socket.id,
          name: u.name,
          location: location,
          channel: channelId,
          message: 'has opened the Outside puzzle 02',
          game: 'grand-hotel-pro',
        },
      });
    }

    if (area.name === 'clue06') {
      setVisibleClue06(true);
      doAction({
        game: 'grand-hotel-pro',
        channel: socket.channel,
        event: 'log',
        message: {
          id: socket.id,
          name: u.name,
          location: location,
          channel: channelId,
          message: 'has opened the Map clue',
          game: 'grand-hotel-pro',
        },
      });
    }
  };

  return (
    <View>
      <Box textAlign="center">
        <ImageMapper
          src={path09}
          width={window.innerWidth}
          height={(window.innerWidth * height) / width}
          map={MAP}
          imgWidth={width}
          onClick={handleClick}
        />
      </Box>
      <Modal
        visible={roomScenario}
        footer={null}
        onCancel={() => {
          addStory('09');
          doAction({
            game: 'grand-hotel-pro',
            channel: socket.channel,
            event: 'story',
            message: {
              story: '09',
              channel: channelId,
              game: 'grand-hotel-pro',
              location: 'Outside',
            },
          });
          setRoomScenario(false);
        }}
        bodyStyle={{ backgroundImage: `url(${scenarioBg})`, color: '#333' }}
      >
        <Box fontSize={20} mb={30}>
          Objectives:
          <ol>
            <li>
              Determine the Furthest Point Reachable by Lauren. Click on Grand
              Hotel icon for instruction.
            </li>
            <li>
              Determine Lauren’s Exit Point. One time chance only. Click on
              point 103 for instruction.
            </li>
          </ol>
        </Box>
      </Modal>
      <Modal
        visible={visibleClue06}
        onCancel={() => {
          doAction({
            game: 'grand-hotel-pro',
            channel: socket.channel,
            event: 'log',
            message: {
              id: socket.id,
              name: u.name,
              location: location,
              channel: channelId,
              message: 'has closed the Map clue',
              game: 'grand-hotel-pro',
            },
          });
          setVisibleClue06(false);
        }}
        footer={null}
      >
        <img src={clue06} alt="Clue" width="100%" />
      </Modal>
      <Modal
        visible={visiblePuzzle06}
        onCancel={() => {
          doAction({
            game: 'grand-hotel-pro',
            channel: socket.channel,
            event: 'log',
            message: {
              id: socket.id,
              name: u.name,
              location: location,
              channel: channelId,
              message: 'has closed the Outside puzzle',
              game: 'grand-hotel-pro',
            },
          });
          setVisiblePuzzle06(false);
        }}
        width={800}
        footer={null}
      >
        <Row gutter={24}>
          <Col xs={24} style={{ textAlign: 'center' }}>
            <img src={puzzle09} width="100%" alt="Puzzle" />
          </Col>
          <Col xs={24}>
            <Box textAlign="center" mt={20}>
              {solves.filter((solve) => solve === '0902').length === 0 ? (
                <>
                  <LockFilled style={{ color: '#FFF', fontSize: 50 }} />
                  <br />
                  <br />
                  You need to solve the other puzzle in this room first before
                  you can attempt to solve this puzzle
                </>
              ) : !end ? (
                <>
                  You need to solve the puzzle above and use the answer
                  combination to open the lock below
                  <br />
                  <br />
                  You can only make <strong>ONE ATTEMPT</strong> to guess the
                  puzzle
                  <br />
                  <br />
                  <CombinationLock
                    combination="091"
                    height={70}
                    onMatch={() => {
                      setSolved(true);
                    }}
                    openText={''}
                  />
                  <br />
                  <br />
                  <Button
                    type="primary"
                    onClick={() => {
                      Modal.confirm({
                        title: 'Make the guess',
                        content: (
                          <div>
                            Are you sure you want to make the guess with the
                            numbers that you have specified? Your team only have
                            one chance to make one guess
                          </div>
                        ),
                        onOk: () => {
                          if (solved) {
                            addSolve('09');

                            doAction({
                              game: 'grand-hotel-pro',
                              channel: socket.channel,
                              event: 'solved',
                              message: {
                                puzzle: '09',
                                channel: channelId,
                                game: 'grand-hotel-pro',
                              },
                            });

                            doAction({
                              game: 'grand-hotel-pro',
                              channel: socket.channel,
                              event: 'log',
                              type: 'solved',
                              message: {
                                id: socket.id,
                                name: u.name,
                                location: location,
                                channel: channelId,
                                puzzle: '09',
                                message:
                                  'has solved the Outside puzzle and solved the mystery',
                                game: 'grand-hotel-pro',
                              },
                            });
                          }

                          doAction({
                            game: 'grand-hotel-pro',
                            channel: socket.channel,
                            event: 'end',
                            message: {
                              channel: channelId,
                              game: 'grand-hotel-pro',
                            },
                          });

                          doAction({
                            game: 'grand-hotel-pro',
                            channel: socket.channel,
                            event: 'log',
                            message: {
                              id: socket.id,
                              name: u.name,
                              location: location,
                              channel: channelId,
                              message: 'has made the final submission',
                              game: 'grand-hotel-pro',
                            },
                          });

                          setEnd(true);
                        },
                      });
                    }}
                  >
                    Submit Final Combination
                  </Button>
                  <br />
                  <br />
                  <Help
                    location={location}
                    puzzle="09"
                    channel={channelId}
                    solution={
                      <Box>
                        <strong>Hint</strong>
                        <br />
                        Lauren can reach this exit just by spending 2 bus
                        tickets and 2 taxi tickets.
                      </Box>
                    }
                  />
                </>
              ) : solves.filter((solve) => solve === '09').length > 0 ||
                solved ? (
                <>
                  <Box fontSize={20}>
                    {visiblePuzzle06 && (
                      <ReactPlayer
                        url="https://youtu.be/31tfOX_5uvA"
                        playing
                        width="100%"
                        height="500px"
                        onPlay={() => {
                          doAction({
                            game: 'grand-hotel-pro',
                            channel: socket.channel,
                            event: 'log',
                            message: {
                              id: socket.id,
                              name: u.name,
                              location: location,
                              channel: channelId,
                              message: `is watching the ${location} success`,
                              game: 'grand-hotel-pro',
                            },
                          });
                          setAudio(false);
                        }}
                        onEnded={() => {
                          setAudio(true);
                          doAction({
                            game: 'grand-hotel-pro',
                            channel: socket.channel,
                            event: 'log',
                            message: {
                              id: socket.id,
                              name: u.name,
                              location: location,
                              channel: channelId,
                              message: `has finished watching the ${location}`,
                              game: 'grand-hotel-pro',
                            },
                          });
                        }}
                      />
                    )}
                  </Box>
                  <br />
                  <br />
                  <CheckCircleFilled
                    style={{
                      fontSize: 100,
                      color: '#52c41a',
                    }}
                  />
                </>
              ) : (
                <>
                  <Box fontSize={20}>
                    {visiblePuzzle06 && (
                      <ReactPlayer
                        url="https://youtu.be/BkqrWCl_eac"
                        playing
                        width="100%"
                        height="500px"
                        onPlay={() => {
                          doAction({
                            game: 'grand-hotel-pro',
                            channel: socket.channel,
                            event: 'log',
                            message: {
                              id: socket.id,
                              name: u.name,
                              location: location,
                              channel: channelId,
                              message: `is watching the ${location} fail`,
                              game: 'grand-hotel-pro',
                            },
                          });
                          setAudio(false);
                        }}
                        onEnded={() => {
                          setAudio(true);
                          doAction({
                            game: 'grand-hotel-pro',
                            channel: socket.channel,
                            event: 'log',
                            message: {
                              id: socket.id,
                              name: u.name,
                              location: location,
                              channel: channelId,
                              message: `has finished watching the ${location} fail`,
                              game: 'grand-hotel-pro',
                            },
                          });
                        }}
                      />
                    )}
                  </Box>
                  <br />
                  <br />
                  <CloseCircleOutlined
                    style={{
                      fontSize: 100,
                      color: '#FF0000',
                    }}
                  />
                </>
              )}
            </Box>
          </Col>
        </Row>
      </Modal>

      <Modal
        visible={visiblePuzzle0602}
        onCancel={() => {
          doAction({
            game: 'grand-hotel-pro',
            channel: socket.channel,
            event: 'log',
            message: {
              id: socket.id,
              name: u.name,
              location: location,
              channel: channelId,
              message: 'has closed the Outside puzzle 02',
              game: 'grand-hotel-pro',
            },
          });
          setVisiblePuzzle0602(false);
        }}
        width={800}
        footer={null}
      >
        <Row gutter={24}>
          <Col xs={24} style={{ textAlign: 'center' }}>
            <img src={puzzle0902} width="100%" alt="Puzzle" />
          </Col>
          <Col xs={24}>
            <Box textAlign="center" mt={20}>
              {solves.filter((solve) => solve === '0902').length === 0 ? (
                <>
                  You need to solve the puzzle above and use the answer
                  combination to open the lock below to reveal the final puzzle
                  <br />
                  <br />
                  <CombinationLock
                    combination="097"
                    height={70}
                    onMatch={() => {
                      message.success(
                        'Congrats! You have solved one out of two puzzles for this room! Solve the other puzzle in the room to complete the game'
                      );
                      addSolve('0902');
                      doAction({
                        game: 'grand-hotel-pro',
                        channel: socket.channel,
                        event: 'notification',
                        message: {
                          type: 'success',
                          title: 'Map Puzzle 02 Solved',
                          game: 'grand-hotel-pro',
                          description: `Your team member ${
                            u.name ? u.name : ''
                          } has successfully solved the puzzle 02 in the Outside! You may now answer the final puzzle`,
                        },
                      });
                      doAction({
                        game: 'grand-hotel-pro',
                        channel: socket.channel,
                        event: 'solved',
                        message: {
                          puzzle: '0902',
                          channel: channelId,
                          game: 'grand-hotel-pro',
                        },
                      });
                      doAction({
                        game: 'grand-hotel-pro',
                        channel: socket.channel,
                        event: 'log',
                        type: 'solved',
                        message: {
                          id: socket.id,
                          name: u.name,
                          location: location,
                          channel: channelId,
                          puzzle: '0902',
                          message: 'has solved the Outside puzzle 02',
                          game: 'grand-hotel-pro',
                        },
                      });
                    }}
                    openText={''}
                  />
                  <br />
                  <br />
                  <Help
                    location={location}
                    puzzle="0902"
                    channel={channelId}
                    solution={
                      <Box>
                        <strong>Hint</strong>
                        <br />
                        Among the possible points that Lauren can reach, use
                        ruler to determine the furthest. The point does not need
                        to be the exit point.
                      </Box>
                    }
                  />
                </>
              ) : (
                <>
                  Your team has successfully solved this puzzle
                  <br />
                  <br />
                  <CheckCircleFilled
                    style={{
                      fontSize: 100,
                      color: '#52c41a',
                    }}
                  />
                </>
              )}
            </Box>
          </Col>
        </Row>
      </Modal>
    </View>
  );
};

const mapStateToProps = (state) => ({
  puzzles: state.puzzles,
  socket: state.socket,
  clues: state.clues,
  solves: state.solves,
  end: state.end,
});

export default connect(mapStateToProps, {
  doAction,
  addPuzzle,
  addClue,
  setNavigation,
  updateMember,
  addSolve,
  addStory,
  setEnd,
  setAudio,
})(Outside);
